
<!-- new theme section is start here -->
<div class="about-us-wrapper bgm-white">
  <div class="container">
    <!-- text section -->
    <div class="p-30 fx-col fx-main-center fx-cross-center">
      <div class="width-responsive text-center fx-col fx-main-center fx-cross-center fx-flex-46-in-col xs-fx-flex-80-in-col sm-fx-flex-72-in-col">
        <p class="m-t-12 f-s-36 f-w-700 p1">We think everything is possible</p>
        <p class="m-t-20 p2">We believe in the power of human potential and in doing everything in our power to see it flourish. That means putting our money where our mouth is and inspiring excellence in sport not only in our backyard, but all around the world.</p>
      </div>
    </div>
    <!-- image grid -->
    <div class="p-30 fx-row">
      <div class="fx-col gt-sm-fx-row fx-fill-size fx-flex-100 print-fx-gap-bottom-20px lt-md-fx-gap-bottom-20px gt-sm-fx-gap-right-20px">
        <div class="fx-col xs-fx-flex-100-in-col print-fx-flex-50-in-col sm-fx-flex-50-in-col gt-sm-fx-flex-50">
          <img
            src="https://cdn.shopify.com/s/files/1/0926/9298/files/FORCEMAJEURE_LIGHTMARINE_4_1200x1600_ecbc368d-33f9-4ae8-ac62-c2e8205511e5_900x.jpg?v=1644345376"
            alt="product-image" width="100%" height="100%">
        </div>
        <div class="fx-col-wrap xs-fx-flex-100-in-col print-fx-flex-50-in-col sm-fx-flex-50-in-col gt-sm-fx-flex-50">
          <div class="fx-row-wrap fx-flex-49-in-col-wrap xs-fx-flex-100-in-col-wrap">
            <img
            src="https://cdn.shopify.com/s/files/1/0926/9298/files/Seamless01_2x_9aae5fcf-bb1f-43a3-aa6b-d42036707085_900x.png?v=1600987079"
            alt="product-image" width="100%">
          </div>
          <div class="bgm-white fx-row-wrap fx-flex-2-in-col-wrap xs-fx-flex-100-in-col-wrap">
          </div>
          <div class="fx-row-wrap fx-flex-49-in-col-wrap xs-fx-flex-100-in-col-wrap lt-md-ew-margin-top-20px">
            <img
            src="https://cdn.shopify.com/s/files/1/0926/9298/files/IMGN_191028_AF1_sRGB91023_JUSTE_04_208_F1_sRGB_900x.jpg?v=1600985793"
            alt="product-image" width="100%">
          </div>
        </div>
      </div>
    </div>
    <!-- text , mat-expansion -->
    <div class="p-30 m-b-20">
      <div  class="fx-col fx-main-center fx-cross-center">
        <div class="width-responsive fx-col fx-main-center fx-cross-center fx-flex-46-in-col xs-fx-flex-80-in-col sm-fx-flex-72-in-col">
          <p class="m-t-20 p2">This demo store uses content from LNDR, an incredible athletic wear brand hailing from London. The content below comes from their website, which you can view here. LNDR was founded by three active, international women, based in London, who wanted to create a brand around "the lifestyle we want to live, the products we want to wear, and the people we wanted to hang out with.</p>
          <p class="m-t-20 p2">We genuinely believe in better quality products and less of them. We believe the day of fast fashion is over - for state of mind and the planet. We don't want a new outfit every month. We want hands down great products that we don't have to think about. LNDR products are made with cutting-edge technology and a fanatical attitude towards quality and fit. It can take factories up to 20 times longer to knit LNDR seamless leggings, for instance, compared to other brands.</p>
          <!-- mat expansion -->
          <div class="m-t-20">
            <div class="about-us-intro">
                <p class="f-s-16 f-w-700 p-b-10">Frequently Asked Questions</p>
                <div class="accordions faq-home-accordions">
                <mat-accordion>
                   <mat-expansion-panel>
                     <mat-expansion-panel-header class="arrow-color">
                       <mat-panel-title>
                            <span class="question font-IBM">Why Glutathione?</span>
                       </mat-panel-title>
                     </mat-expansion-panel-header>
                     <p class="font-IBM">Glutathione (GSH) performs many functions critical to optimal health and performance. It is the body's master antioxidant.  It is a critical detoxifier of the cell anda primary protector of immune cells and immune function. You may learn more about glutathione's critical role with immune cells, their protection and their reproduction by searching: Glutathione and Immune cells, (or immune function or immune system).</p>
                   </mat-expansion-panel>
                   <mat-expansion-panel>
                       <mat-expansion-panel-header class="arrow-color">
                         <mat-panel-title>
                             <span class="question font-IBM">What should I be feeling?</span>
                         </mat-panel-title>
                       </mat-expansion-panel-header>
                       <p class="font-IBM">You know your body better than anyone, some people feel better after one dosage, some people take up to 2 weeks before they notice any difference. There is a cumulative effect in taking NutriSwish. If you don't feel any difference in your energy levels, physical output, etc., pay attention to your sleeping patterns. Glutathione is known to aid in your body's sleep process.  </p>
                     </mat-expansion-panel>
                 </mat-accordion>
               </div>
            </div>
          </div>
          <!-- p tag -->
          <p class="m-t-30 p2">Each and every LNDR product is precision engineered to perform, whether you're sweating through a METCON, pounding the city streets, or meeting up with mates at the pub for a few well-earned negroni's. Clean, fresh styling and tonal colour-ways make for easy-to-wear, put-together looks that you can just throw on and go. We don't do trends, gimmicks, influencers or compromise. We just do killer kit that feels as great as it looks.</p>
      </div>
      </div>
    </div>
    <hr style="margin:0px 28px; border-color:rgba(0,0,0,0.1)">
    <!-- blog posts -->
    <div class="p-30">
      <div class="fx-col">
        <p class="f-s-24 f-w-700">Blog posts</p>
        <div class="m-t-10 fx-col gt-xs-fx-row fx-main-start fx-cross-start fx-fill-size fx-flex-100-in-col print-fx-gap-bottom-20px xs-fx-gap-bottom-20px gt-xs-fx-gap-right-20px"
>
          <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
            <div class="img-hover text-center">
              <img
                src="https://cdn.shopify.com/s/files/1/0926/9298/articles/Block_01.jpg?v=1601060153&width=550"
                alt="Leggings" width="100%">
            </div>
            <p class="f-s-18 f-w-700 m-t-10">The Cheapest, Best Workout</p>
            <p class="m-t-20 f-s-14">We don't want a new outfit every month. We want hands down great products that we don't have to think about.</p>

          </div>
          <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
            <div class="img-hover text-center">
              <img
                src="https://cdn.shopify.com/s/files/1/0926/9298/articles/Block_02.jpg?v=1601059385&width=550"
                alt="Leggings" width="100%">
            </div>
            <p class="f-s-18 f-w-700 m-t-10">Running Your First 10k</p>
            <p class="m-t-20 f-s-14">We genuinely believe in better quality products and less of them. We believe the day of fast fashion is over - for state of mind and the planet.  </p>
          </div>
          <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
            <div class="img-hover text-center">
              <img
                src="https://cdn.shopify.com/s/files/1/0926/9298/articles/Block_03.jpg?v=1601059755&width=550"
                alt="Leggings" width="100%">
            </div>
            <p class="f-s-18 f-w-700 m-t-10">Strength Training</p>
            <p class="m-t-20 f-s-14">It can take factories up to 20 times longer to knit LNDR seamless leggings, for instance, compared to other brands.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>    